import React from 'react';
import { Slide } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import ContextualSupportLinks from './ContextualSupportLinks';
import LoadableSupportContent from './LoadableSupportContent';
import RoutePrefixContext from 'new/contexts/RoutePrefixContext';
import { NavAction } from 'new/components/header/Header';
import { ReactComponent as SupportIcon } from 'new/components/icons/fi-rr-interrogation.svg';

import './ContextualSupport.scss';

class ContextualSupport extends React.Component {
  static contextType = RoutePrefixContext;
  constructor(props) {
    super(props);

    this.state = {
      whatsNewIFrame: false,
    };

    this._handleOpenClicked = this._handleOpenClicked.bind(this);
    this._handleCloseClicked = this._handleCloseClicked.bind(this);
    this._toggleWhatsNew = this._toggleWhatsNew.bind(this);
  }

  _toggleWhatsNew(flag) {
    this.setState({ whatsNewIFrame: flag });
  }

  render() {
    const { whatsNewIFrame } = this.state;
    const { visible } = this.props;

    return (
      <div className="contextual-support">
        <NavAction title="Help" Icon={SupportIcon} onClick={this._handleOpenClicked} />
        {visible && (
          <div>
            <div
              onClick={this._handleCloseClicked}
              className="modal-fader z-index-context-drawer"
            />

            <Slide direction="left" in={visible}>
              <div className="help-panel-container">
                <header className="help-panel-header">
                  <h2>Help</h2>
                  <ContextualSupportLinks toggleWhatsNew={this._toggleWhatsNew} />
                  <CloseIcon
                    fontSize="large"
                    className="close-icon circled"
                    onClick={this._handleCloseClicked}
                  />
                </header>
                <LoadableSupportContent
                  {...this.props}
                  whatsNewIFrame={whatsNewIFrame}
                  toggleWhatsNew={this._toggleWhatsNew}
                />
              </div>
            </Slide>
          </div>
        )}
      </div>
    );
  }

  _handleOpenClicked() {
    this.props.setSupportVisible(true);
  }

  _handleCloseClicked() {
    this.props.setSupportVisible(false);
  }
}

export default ContextualSupport;
